import { ContentTypeUsesKeySystemRootKeyEncryption, ContentTypeUsesRootKeyEncryption, DecryptedPayload, EncryptedPayload, PayloadEmitSource, SureFindPayload, } from '@standardnotes/models';
import { isErrorDecryptingParameters } from '@standardnotes/encryption';
export class DecryptErroredTypeAPayloads {
    constructor(payloads, _decryptTypeAPayloadWithKeyLookup) {
        this.payloads = payloads;
        this._decryptTypeAPayloadWithKeyLookup = _decryptTypeAPayloadWithKeyLookup;
    }
    async execute() {
        const erroredRootPayloads = this.payloads.invalidPayloads.filter((i) => ContentTypeUsesRootKeyEncryption(i.content_type) || ContentTypeUsesKeySystemRootKeyEncryption(i.content_type));
        if (erroredRootPayloads.length === 0) {
            return;
        }
        const resultParams = await this._decryptTypeAPayloadWithKeyLookup.executeMany(erroredRootPayloads);
        const decryptedPayloads = resultParams.map((params) => {
            const original = SureFindPayload(erroredRootPayloads, params.uuid);
            if (isErrorDecryptingParameters(params)) {
                return new EncryptedPayload({
                    ...original.ejected(),
                    ...params,
                });
            }
            else {
                return new DecryptedPayload({
                    ...original.ejected(),
                    ...params,
                });
            }
        });
        await this.payloads.emitPayloads(decryptedPayloads, PayloadEmitSource.LocalChanged);
    }
}
